import { baseUrl } from './constants';
import { toast } from 'react-toastify';
import axios from 'axios';

const PostObject = async (url, obj, hideSuccessMsg = false) => {
  try {
    // Get auth tokens from storage
    const authTokens = localStorage.getItem('tokens');
    const tokens = authTokens ? JSON.parse(authTokens) : null;
    
    if (!tokens?.token) {
      toast.error('Please login first');
      throw new Error('Authentication required');
    }

    // Setup request config
    const config = {
      method: 'POST',
      url: `${baseUrl}/${url.replace(/^\/+/, '')}`, // Remove leading slashes
      headers: {
        'Authorization': `${tokens.token}`,
        'Content-Type': 'application/json',
      },
      data: obj
    };

    // Make the request
    const response = await axios(config);

    // Handle successful response
    if (response?.data) {
      if (!hideSuccessMsg && response.data.message) {
        toast.success(response.data.message);
      }
      return response.data;
    }

    throw new Error('Invalid response from server');

  } catch (error) {
    // Handle different types of errors
    if (error.response) {
      // Server responded with error
      const message = error.response.data?.message || 'Server error occurred';
      toast.error(message);
    } else if (error.request) {
      // Request made but no response
      toast.error('No response from server. Please check your connection.');
    } else {
      // Other errors
      toast.error(error.message || 'An error occurred');
    }
    
    throw error;
  }
};

export default PostObject;
